module.exports = __webpack_public_path__ + "static/media/balance_3_조명과인테리어.42cd17b3.JPG";